import React from 'react';
import { GoogleReCaptchaProvider } from 'react-google-recaptcha-v3';
import config from '../../config';

export const ReCaptchaProvider = ({ children }: { children: React.ReactNode }) => (
    <GoogleReCaptchaProvider reCaptchaKey={config.RECAPTCHA_SITE_KEY}>{children}</GoogleReCaptchaProvider>
);
